import { UrlApi } from "../../../../../services/apirest";

export const reenviarPorMailService = async (idComprobante) => {
  const response = await fetch(`${UrlApi}/comprobantes/mail/${idComprobante}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      enviadoxmail: 0,
    }),
  });

  if (!response.ok) {
    throw new Error("Error al reenviar el comprobante");
  }

  return response.json();
};
